class BundleUpsellModal extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
    }

    requestAnimationFrame(() => this._setup());
  }

  _setup() {
    const section = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
    section?.querySelectorAll('[type="submit"][name="add"]').forEach((btn) => {
      btn.addEventListener('click', this.onAtcClick.bind(this), true);
    });

    this._acceptBtn          = this.querySelector('.bundle-upsell-modal__accept');
    this._errorEl            = this.querySelector('.bundle-upsell-modal__error');
    this._membershipBlock    = this.querySelector('.bundle-upsell-modal__membership');
    this._membershipNameEl   = this.querySelector('[data-membership-name]');
    this._membershipCycleEl  = this.querySelector('[data-membership-cycle]');
    this._membershipPriceEl  = this.querySelector('[data-membership-price]');
    this._bundlePriceEl      = this.querySelector('[data-bundle-price]');
    this._bundleComparePriceEl = this.querySelector('[data-bundle-compare-price]');
    this._bundleImageEl      = this.querySelector('.bundle-upsell-modal__bundle-image');
    this._mainImageEl        = this.querySelector('.bundle-upsell-modal__main-image');

    try {
      this._variantImagesMap = JSON.parse(
        this.querySelector('.js-bundle-main-variant-images')?.textContent || '{}'
      );
    } catch {
      this._variantImagesMap = {};
    }

    this._acceptBtn.addEventListener('click', this.onAccept.bind(this));
    this.querySelector('.bundle-upsell-modal__decline').addEventListener('click', this.onDecline.bind(this));
    this.querySelector('.bundle-upsell-modal__close').addEventListener('click', this.onDecline.bind(this));
    this.querySelector('[data-bundle-variant-select]')?.addEventListener('change', this.onVariantChange.bind(this));
    this.querySelector('.bundle-upsell-modal__overlay').addEventListener('click', (e) => {
      if (e.target === e.currentTarget) this.onDecline();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.hasAttribute('open')) this.onDecline();
    });
  }

  onAtcClick(evt) {
    this.form = evt.target.closest('form');
    this.originalButton = evt.target;
    this.isWithoutMembership = evt.target.dataset.addWithoutMembership === 'true';

    evt.preventDefault();

    this._membershipData = this.readMembershipData();

    this.showError(null);
    this.populateMembershipInfo();
    this._updateMainImage();
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
  }

  populateMembershipInfo() {
    if (!this._membershipData) {
      this._membershipBlock.hidden = true;
      return;
    }

    this._membershipNameEl.textContent  = this._membershipData.planName;
    this._membershipCycleEl.textContent = this._membershipData.billingCycle;

    const activeCard = document.querySelector('.js-membership-service-card.is-active');
    const durationEl = activeCard?.querySelector('.js-membership-service-card-price-duration');
    const hasDuration = durationEl && !durationEl.classList.contains('is-hidden') && durationEl.innerHTML.trim();
    const fallbackEl = activeCard?.querySelector('.js-membership-service-card-price');
    this._membershipPriceEl.innerHTML = hasDuration ? durationEl.innerHTML : (fallbackEl?.textContent?.trim() ?? '');

    this._membershipBlock.hidden = false;
  }

  onVariantChange(evt) {
    const opt = evt.target.selectedOptions[0];
    this._bundlePriceEl.textContent = opt.dataset.price;
    if (this._bundleComparePriceEl) this._bundleComparePriceEl.textContent = opt.dataset.comparePrice || '';
    this.dataset.bundleVariantId = opt.value;
    if (this._bundleImageEl && opt.dataset.image) this._bundleImageEl.src = opt.dataset.image;
  }

  _updateMainImage() {
    const variantId = this.form?.querySelector('[name="id"]')?.value;
    if (!variantId) return;
    const url = this._variantImagesMap?.[variantId];
    if (url && this._mainImageEl) this._mainImageEl.src = url;
  }

  readMembershipData() {
    if (this.isWithoutMembership) return null;
    const activeCard = document.querySelector('.js-membership-service-card.is-active');
    if (!activeCard) return null;
    const subVariantId = activeCard.dataset.variantId;
    const sellingPlanId = document.getElementById('main-selling-plan-input')?.value;
    if (!subVariantId || !sellingPlanId || sellingPlanId === '0') return null;
    const planName = activeCard.querySelector('.membership-service-card__heading')?.textContent?.trim() ?? '';
    const activeTab = document.querySelector('.js-membership-service-tab-button.is-active');
    const billingCycle = activeTab?.querySelector('.membership-service-tabs__button-text')?.textContent?.trim() ?? '';
    return { subVariantId, sellingPlanId, planName, billingCycle };
  }

  async onAccept() {
    this.setLoading(true);
    this.showError(null);

    const bundleVariantId = this.dataset.bundleVariantId;
    const membershipData = this._membershipData;

    const bundleItem = {
      id: bundleVariantId,
      quantity: 1,
      ...(membershipData && { properties: { Membership: `${membershipData.planName}, ${membershipData.billingCycle}` } })
    };

    const items = [bundleItem];

    if (membershipData) {
      items.push({
        id: membershipData.subVariantId,
        quantity: 1,
        selling_plan: membershipData.sellingPlanId,
        properties: { _mainSubProduct: bundleVariantId }
      });
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items })
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Could not add product');
      }

      this.close();
      this.form.requestSubmit(this.originalButton);
    } catch (err) {
      this.showError(err.message);
    } finally {
      this.setLoading(false);
    }
  }

  onDecline() {
    this.close();
    this.form?.requestSubmit(this.originalButton);
  }

  close() {
    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    this._membershipData = null;
  }

  setLoading(state) {
    this._acceptBtn.disabled = state;
  }

  showError(msg) {
    this._errorEl.hidden = !msg;
    this._errorEl.textContent = msg ?? '';
  }
}

customElements.define('bundle-upsell-modal', BundleUpsellModal);
